import { FC, ReactElement } from 'react';

type ExercisePickerChipProps = {
  label: string;
  removeLabel: string;
  onRemove: () => void;
};

const ExercisePickerChip: FC<ExercisePickerChipProps> = ({
  label,
  removeLabel,
  onRemove,
}: ExercisePickerChipProps): ReactElement => {
  return (
    <span className="badge badge-tag d-inline-flex align-items-center gap-2 flex-shrink-0">
      <span className="text-truncate" style={{ maxWidth: '20rem' }} title={label}>
        {label}
      </span>

      <button
        type="button"
        aria-label={removeLabel}
        onClick={onRemove}
        className="btn btn-link p-0 border-0 lh-1 text-reset"
      >
        <i className="fas fa-times" />
      </button>
    </span>
  );
};

export default ExercisePickerChip;
